export { default } from './Reviews';
export type { Props } from './Reviews';
